var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "account-card-rg" }, [
    _c("div", { staticClass: "accont-area flex-row-between-center" }, [
      _c(
        "div",
        { staticClass: "title-left flex-flex1 flex-row-start-center" },
        [
          _c("img", { attrs: { src: _vm.img.userIcon, width: "48", alt: "" } }),
          _vm._v(" "),
          _c("span", { staticClass: "fs-14 account-label" }, [
            _vm._v("银行卡绑定")
          ])
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "not-activation-label fs-14" }, [
        _vm._v("注意：如需换绑银行卡，请联系锐锢业务员")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "man-content-area" }, [
      _c("div", { staticClass: "card-item" }, [
        _c("div", { staticClass: "card-title flex-row-start-center" }, [
          _c("img", { attrs: { src: _vm.img.bankLogo, width: 20, alt: "" } }),
          _vm._v(" "),
          _c("span", { staticClass: "title-text" }, [_vm._v("银行信息")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 8 } },
              [
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("账户类型:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.accountType
                                  ? _vm.pageAccountWithBankAccountVO
                                      .accountType === 1
                                    ? "对公账户"
                                    : " 个人账户"
                                  : ""
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.accountType
                                  ? _vm.pageAccountWithBankAccountVO
                                      .accountType === 1
                                    ? "账户名称:"
                                    : "持卡人姓名:"
                                  : ""
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value" },
                          [
                            _c("MaskViewVue", {
                              attrs: {
                                type: "maskName",
                                maskVal:
                                  _vm.pageAccountWithBankAccountVO.accountName,
                                customParams: {
                                  expand: JSON.stringify({
                                    xAPIVersion: "V1.0",
                                    xSystemID: "passport"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.accountType
                                  ? _vm.pageAccountWithBankAccountVO
                                      .accountType === 1
                                    ? "账户号码:"
                                    : "银行卡号:"
                                  : ""
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value" },
                          [
                            _c("MaskViewVue", {
                              attrs: {
                                type: "maskBankCard",
                                maskVal:
                                  _vm.pageAccountWithBankAccountVO
                                    .accountNumber,
                                customParams: {
                                  expand: JSON.stringify({
                                    xAPIVersion: "V1.0",
                                    xSystemID: "passport"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("开户银行:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.bankName
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [_vm._v("省份:")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.provinceName
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [_vm._v("市/县:")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.cityName
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("开户支行:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.branchBankName
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("开户行地址:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.branchBankName
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bd135ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bd135ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purseSetting/binding/components/accountCardRG.vue
// module id = null
// module chunks = 